export default "__VITE_ASSET__CzQpe$UA__"